import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as Save } from '../../assets/svg/Save.svg';
import '../../styles/modals/StudentInfoModal.css';
import { Controller, useForm } from 'react-hook-form';
import Loading from '../Loading';
import TypesDropDown from './TypesDropDown';
import { updateUser } from '../../server/server';

function CreateEditUserModal({ modalIsOpen, closeModal, user, onSuccess }: { modalIsOpen: boolean; closeModal: () => void; user: any; onSuccess?: () => void }) {
	const [processing, setProcessing] = useState(false);
	const { register, handleSubmit, watch, reset, formState, getValues, setValue, control } = useForm({
		mode: 'onChange',
		defaultValues: {
			firstName: '',
			lastName: '',
			email: '',
		},
	});
	const { isDirty, isValid, errors } = formState;

	useEffect(() => {
		const element = document.getElementById('home');
		ReactModal.setAppElement('#root');
		if (modalIsOpen) {
			if (!!element) element.style.filter = 'blur(5px)';
			if (!!user?.id) {
				setValue('firstName', user?.firstName, { shouldValidate: true });
				setValue('lastName', user?.lastName, { shouldValidate: true });
				setValue('email', user?.email, { shouldValidate: true });
			}
		} else {
			if (!!element) element.style.filter = 'unset';
		}
	}, [modalIsOpen, user]);

	const onSubmit = async () => {
		setProcessing(true);

		try {
			const resp = await updateUser({ ...getValues(), id: user?.id });

			if (resp.status !== 201) {
				alert('Error updating user');
				return;
			}

			onSuccess?.();
			closeModal();
		} catch (error) {
			console.error(error);
			alert('Unexpected error');
		} finally {
			setProcessing(false);
		}
	};

	const cleanUpFunction = () => {
		reset();
	};

	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => cleanUpFunction()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 0,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 900,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  '>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>

				<form onSubmit={handleSubmit(onSubmit)} className='bg-white rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[30px]'>
					<div className='flex flex-row items-center'>
						<div className='flex-1'>
							<p className='text-primaryViolet font-semibold text-3xl text-left'>{user === null ? 'Create new user' : 'Edit user profile'}</p>
						</div>
					</div>
					<div className='mt-5'>
						<p className='text-primaryViolet font-semibold text-lg text-left'>First name</p>
						<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.firstName?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
							<input
								className={`w-full text-primaryViolet ${errors.firstName?.type === 'required' ? 'placeholder:text-redError' : ''}`}
								placeholder={`Type name`}
								{...register('firstName', { required: true })}
								style={{ backgroundColor: 'transparent' }}
							/>
							<p className='text-redError   text-nowrap'>{errors.firstName?.type === 'required' ? '*This field is required' : ''}</p>
						</div>
					</div>
					<div className='mt-5'>
						<p className='text-primaryViolet font-semibold text-lg text-left'>Last name</p>
						<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.lastName?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
							<input
								className={`w-full text-primaryViolet ${errors.lastName?.type === 'required' ? 'placeholder:text-redError' : ''}`}
								placeholder={`Type surname`}
								{...register('lastName', { required: true })}
								style={{ backgroundColor: 'transparent' }}
							/>
							<p className='text-redError   text-nowrap'>{errors.lastName?.type === 'required' ? '*This field is required' : ''}</p>
						</div>
					</div>
					<div className='mt-5'>
						<p className='text-primaryViolet font-semibold text-lg text-left'>Email</p>
						<div className={`border-b  p-2 mt-2 flex flex-row items-center ${errors.email?.type === 'required' ? 'border-b-redError' : 'border-b-deselectPurple'}`}>
							<input
								className={`w-full text-primaryViolet ${errors.email?.type === 'required' ? 'placeholder:text-redError' : ''}`}
								placeholder={`Type email`}
								{...register('email', { required: true })}
								style={{ backgroundColor: 'transparent' }}
							/>
							<p className='text-redError   text-nowrap'>{errors.email?.type === 'required' ? '*This field is required' : ''}</p>
						</div>
					</div>
					{/* <div className='mt-4'>
						<TypesDropDown list={['parent', 'child']} register={register} registerField='type' errors={errors.type?.type} label='Type' selectedValue={type} setSelectedValue={handleType} />
					</div> */}
					<div className='flex flex-row justify-end w-full gap-5'>
						{/* <div
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff]  h-[60px] button-transparent-class'
							onClick={closeModal}
						>
							<p className='text-[18px] text-primaryViolet leading-5 font-semibold mr-3 '>Back</p>
						</div> */}
						<button
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-primaryViolet  min-h-[60px] button-save-class transition'
							disabled={processing}
						>
							{processing ? (
								<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
							) : (
								<div className='flex flex-row items-center justify-center'>
									<p className='text-[18px]  leading-5 font-semibold mr-3 '>Save</p>
									<Save />
								</div>
							)}
						</button>
					</div>
				</form>
			</div>
		</ReactModal>
	);
}

export default CreateEditUserModal;
